// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeLogo-space1-gM8ZE {
	margin-bottom: 6px !important;
}

.HomeLogo-space2-jqrQb {
	margin-bottom: 12px !important;
}

.HomeLogo-space3-Uricd {
	margin-bottom: 18px !important;
}

.HomeLogo-space4-WxfqU {
	margin-bottom: 24px !important;
}

.HomeLogo-space5-YvXAW {
	margin-bottom: 30px !important;
}

.HomeLogo-space6-mdR2v {
	margin-bottom: 36px !important;
}

.HomeLogo-space7-qp3WN {
	margin-bottom: 42px !important;
}

.HomeLogo-space8-dveap {
	margin-bottom: 48px !important;
}

.HomeLogo-spaceTop1-Q5QMQ {
	margin-top: 6px !important;
}

.HomeLogo-spaceTop2-A_lnS {
	margin-top: 12px !important;
}

.HomeLogo-spaceTop3-bU6sR {
	margin-top: 18px !important;
}

.HomeLogo-spaceTop4-al063 {
	margin-top: 24px !important;
}

.HomeLogo-spaceTop5-ySm6O {
	margin-top: 30px !important;
}

.HomeLogo-spaceTop6-P21uh {
	margin-top: 36px !important;
}

.HomeLogo-spaceTop7-niA8m {
	margin-top: 42px !important;
}

.HomeLogo-spaceTop8-Mi5BN {
	margin-top: 48px !important;
}

.HomeLogo-noMargin-l2s2N {
	margin: 0px !important;
}

.HomeLogo-padding1-_XCTG {
	padding-bottom: 6px !important;
}

.HomeLogo-padding2-olwKM {
	padding-bottom: 12px !important;
}

.HomeLogo-padding3-cvns7 {
	padding-bottom: 18px !important;
}

.HomeLogo-padding4-fBQaC {
	padding-bottom: 24px !important;
}

.HomeLogo-padding5-lnw3F {
	padding-bottom: 30px !important;
}

.HomeLogo-padding6-lcpNn {
	padding-bottom: 36px !important;
}

.HomeLogo-padding7-kSh5v {
	padding-bottom: 42px !important;
}

.HomeLogo-paddingTop1-yJlUE {
	padding-top: 6px !important;
}

.HomeLogo-paddingTop2-odExt {
	padding-top: 12px !important;
}

.HomeLogo-paddingTop3-XlBd6 {
	padding-top: 18px !important;
}

.HomeLogo-paddingTop4-qVxrO {
	padding-top: 24px !important;
}

.HomeLogo-paddingTop5-vT_5b {
	padding-top: 30px !important;
}

.HomeLogo-paddingTop6-ZFv0N {
	padding-top: 36px !important;
}

.HomeLogo-paddingTop7-Z7mC1 {
	padding-top: 42px !important;
}

.HomeLogo-noPadding-ewCGD {
	padding: 0px !important;
}

.HomeLogo-spaceMarginBottom0-mQgc0 {
	margin-bottom: 0;
}

.HomeLogo-textBold-v6MHn {
	font-weight: 500 !important;
}

.HomeLogo-textBolder-VHnTN {
	font-weight: 700 !important;
}

.HomeLogo-textNormal-GshDr {
	font-weight: normal !important;
}

/*New Design Text Colors */

.HomeLogo-textDarkBlue-dyB9x {
	color: rgb(20, 39, 94) !important;
}

.HomeLogo-textLightBlue-CKwFa {
	color: rgb(57, 87, 106) !important;
}

.HomeLogo-textLightSandleGreen-dbIA6 {
	color: rgb(76, 86, 41) !important;
}

.HomeLogo-textLightBrown-kfNG3 {
	color: rgb(115, 79, 33) !important;
}

.HomeLogo-textMediumMaroon-K4I9t {
	color: rgb(87, 37, 51) !important;
}

.HomeLogo-textBrown-vycqj {
	color: rgb(160, 47, 24) !important;
}

.HomeLogo-textMaroon-pRZIf {
	color: rgb(155, 49, 67) !important;
}

.HomeLogo-textDarkBrown-vdQfK {
	color: rgb(83, 18, 16) !important;
}

.HomeLogo-textMediumBrown-_D91G {
	color: rgb(142, 28, 10) !important;
}

.HomeLogo-textSkyBlue-omvHs {
	color: rgb(37, 117, 141) !important;
}

.HomeLogo-textGray-dzJQs {
	color: rgb(77, 65, 51) !important;
}

.HomeLogo-errorMessage-PDyre {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.HomeLogo-userText-cc9xO {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.HomeLogo-panelHeader-RJyLK {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.HomeLogo-exportSection-fP5tI {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.HomeLogo-exportSectionGridSub-sMvTC {
	grid-template-columns: 50% 49% !important;
}

.HomeLogo-exportText-bIwEU {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.HomeLogo-exportLinkImg-jNmCo {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.HomeLogo-exportImg-y8fFI {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.HomeLogo-linkBtn-LH6Qa {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.HomeLogo-table-VjfpE {
	display: table;
}

.HomeLogo-tableRow-pgJaT {
	display: table-row;
}

.HomeLogo-tableCell-TChQc {
	display: table-cell;
	float: none;
}

.HomeLogo-formGroup-aieaA {
	margin-bottom: 6px;
}

.HomeLogo-marginTop0-R4Deb {
	margin-top: 0;
}

.HomeLogo-marginBottom20-afBXG {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.HomeLogo-bannerImageBg-XC2F0 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.HomeLogo-bannerDelete-tNzL8 {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.HomeLogo-exportLink-_C3rk {
	padding-top: 10px;
	padding-right: 10px;
}

.HomeLogo-seachContent-bzY5X {
	padding-left: 0px;
	margin-bottom: 5px;
}

.HomeLogo-marginBottom9-QpTIM {
	margin-bottom: 9px;
}

.HomeLogo-spaceTop52-uzQeU {
	margin-top: 52px;
}

.HomeLogo-profileViewInner-KDVx5 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.HomeLogo-profileViewMain-xj3nV {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.HomeLogo-profileViewlabel-MJxE8 {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.HomeLogo-profileViewMainContent-VzRYH {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.HomeLogo-reviewsFormStar-MJo_z {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.HomeLogo-reviewsFormStar-MJo_z svg {
	cursor: pointer;
}

.HomeLogo-addLanguageText-kSWNb {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.HomeLogo-exportSection-fP5tI {
		grid-template-columns: 100%;
	}

	.HomeLogo-spaceTop52-uzQeU {
		margin-top: 18px;
	}

	.HomeLogo-exportText-bIwEU {
		float: none;
		margin-top: 12px;
	}

	.HomeLogo-exportSectionGridSub-sMvTC {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.HomeLogo-profileViewlabel-MJxE8 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.HomeLogo-profileViewMainContent-VzRYH {
		width: 100%;
		text-align: center;
	}

	.HomeLogo-panelHeader-RJyLK {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `HomeLogo-space1-gM8ZE`,
	"space2": `HomeLogo-space2-jqrQb`,
	"space3": `HomeLogo-space3-Uricd`,
	"space4": `HomeLogo-space4-WxfqU`,
	"space5": `HomeLogo-space5-YvXAW`,
	"space6": `HomeLogo-space6-mdR2v`,
	"space7": `HomeLogo-space7-qp3WN`,
	"space8": `HomeLogo-space8-dveap`,
	"spaceTop1": `HomeLogo-spaceTop1-Q5QMQ`,
	"spaceTop2": `HomeLogo-spaceTop2-A_lnS`,
	"spaceTop3": `HomeLogo-spaceTop3-bU6sR`,
	"spaceTop4": `HomeLogo-spaceTop4-al063`,
	"spaceTop5": `HomeLogo-spaceTop5-ySm6O`,
	"spaceTop6": `HomeLogo-spaceTop6-P21uh`,
	"spaceTop7": `HomeLogo-spaceTop7-niA8m`,
	"spaceTop8": `HomeLogo-spaceTop8-Mi5BN`,
	"noMargin": `HomeLogo-noMargin-l2s2N`,
	"padding1": `HomeLogo-padding1-_XCTG`,
	"padding2": `HomeLogo-padding2-olwKM`,
	"padding3": `HomeLogo-padding3-cvns7`,
	"padding4": `HomeLogo-padding4-fBQaC`,
	"padding5": `HomeLogo-padding5-lnw3F`,
	"padding6": `HomeLogo-padding6-lcpNn`,
	"padding7": `HomeLogo-padding7-kSh5v`,
	"paddingTop1": `HomeLogo-paddingTop1-yJlUE`,
	"paddingTop2": `HomeLogo-paddingTop2-odExt`,
	"paddingTop3": `HomeLogo-paddingTop3-XlBd6`,
	"paddingTop4": `HomeLogo-paddingTop4-qVxrO`,
	"paddingTop5": `HomeLogo-paddingTop5-vT_5b`,
	"paddingTop6": `HomeLogo-paddingTop6-ZFv0N`,
	"paddingTop7": `HomeLogo-paddingTop7-Z7mC1`,
	"noPadding": `HomeLogo-noPadding-ewCGD`,
	"spaceMarginBottom0": `HomeLogo-spaceMarginBottom0-mQgc0`,
	"textBold": `HomeLogo-textBold-v6MHn`,
	"textBolder": `HomeLogo-textBolder-VHnTN`,
	"textNormal": `HomeLogo-textNormal-GshDr`,
	"textDarkBlue": `HomeLogo-textDarkBlue-dyB9x`,
	"textLightBlue": `HomeLogo-textLightBlue-CKwFa`,
	"textLightSandleGreen": `HomeLogo-textLightSandleGreen-dbIA6`,
	"textLightBrown": `HomeLogo-textLightBrown-kfNG3`,
	"textMediumMaroon": `HomeLogo-textMediumMaroon-K4I9t`,
	"textBrown": `HomeLogo-textBrown-vycqj`,
	"textMaroon": `HomeLogo-textMaroon-pRZIf`,
	"textDarkBrown": `HomeLogo-textDarkBrown-vdQfK`,
	"textMediumBrown": `HomeLogo-textMediumBrown-_D91G`,
	"textSkyBlue": `HomeLogo-textSkyBlue-omvHs`,
	"textGray": `HomeLogo-textGray-dzJQs`,
	"errorMessage": `HomeLogo-errorMessage-PDyre`,
	"userText": `HomeLogo-userText-cc9xO`,
	"panelHeader": `HomeLogo-panelHeader-RJyLK`,
	"exportSection": `HomeLogo-exportSection-fP5tI`,
	"exportSectionGridSub": `HomeLogo-exportSectionGridSub-sMvTC`,
	"exportText": `HomeLogo-exportText-bIwEU`,
	"exportLinkImg": `HomeLogo-exportLinkImg-jNmCo`,
	"exportImg": `HomeLogo-exportImg-y8fFI`,
	"linkBtn": `HomeLogo-linkBtn-LH6Qa`,
	"table": `HomeLogo-table-VjfpE`,
	"tableRow": `HomeLogo-tableRow-pgJaT`,
	"tableCell": `HomeLogo-tableCell-TChQc`,
	"formGroup": `HomeLogo-formGroup-aieaA`,
	"marginTop0": `HomeLogo-marginTop0-R4Deb`,
	"marginBottom20": `HomeLogo-marginBottom20-afBXG`,
	"bannerImageBg": `HomeLogo-bannerImageBg-XC2F0`,
	"bannerDelete": `HomeLogo-bannerDelete-tNzL8`,
	"exportLink": `HomeLogo-exportLink-_C3rk`,
	"seachContent": `HomeLogo-seachContent-bzY5X`,
	"marginBottom9": `HomeLogo-marginBottom9-QpTIM`,
	"spaceTop52": `HomeLogo-spaceTop52-uzQeU`,
	"profileViewInner": `HomeLogo-profileViewInner-KDVx5`,
	"profileViewMain": `HomeLogo-profileViewMain-xj3nV`,
	"profileViewlabel": `HomeLogo-profileViewlabel-MJxE8`,
	"profileViewMainContent": `HomeLogo-profileViewMainContent-VzRYH`,
	"reviewsFormStar": `HomeLogo-reviewsFormStar-MJo_z`,
	"addLanguageText": `HomeLogo-addLanguageText-kSWNb`
};
module.exports = ___CSS_LOADER_EXPORT___;
